import { Spin, Descriptions, Image, Typography, message } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getFixSkuByScan } from '../../network/FixSku'
import { getCurrencySymbol } from '../../utils/currencyUtils'

const { Title, Text } = Typography
const baseUrl = process.env.REACT_APP_API_URL || ''

const PublicFixSku = () => {
  const { fixSkuId } = useParams()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)

  useEffect(() => {
    if (!fixSkuId) return
    setLoading(true)
    setError(null)
    getFixSkuByScan(fixSkuId)
      .then(setData)
      .catch((err) => {
        setError(err?.response?.data?.message || err?.message || 'Failed to load fix SKU')
        message.error('Failed to load fix SKU')
      })
      .finally(() => setLoading(false))
  }, [fixSkuId])

  const scrollableStyle = { height: '100vh', overflowY: 'auto' }

  if (loading) {
    return (
      <div style={scrollableStyle}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
          <Spin size="large" />
        </div>
      </div>
    )
  }

  if (error || !data) {
    return (
      <div style={scrollableStyle}>
        <div style={{ padding: 24, textAlign: 'center' }}>
          <Text type="danger">{error || 'Fix SKU not found'}</Text>
        </div>
      </div>
    )
  }

  const name = data.name || {}
  const description = data.description || {}
  const currencySymbol = data.store?.currency ? getCurrencySymbol(data.store.currency) : ''

  return (
    <div style={scrollableStyle}>
    <div style={{ backgroundColor: '#000', padding: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div className="login-logo" style={{ backgroundImage: 'url(/images/whitelogo.svg)' }}/>
    </div>
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>

      {data.mainPicture?.uri && (
        <div style={{ marginBottom: 24 }}>
          <Image
            src={`${baseUrl}/storage/fixed-sku-main-picture/${data.mainPicture.uri}`}
            alt={name.en || name.zh || data.sku}
            style={{ maxWidth: 375, maxHeight: 513, objectFit: 'contain' }}
          />
        </div>
      )}

      <Descriptions bordered column={1} size="small">
        <Descriptions.Item label="SKU">{data.sku}</Descriptions.Item>
        {name.en && <Descriptions.Item label="Name (English)">{name.en}</Descriptions.Item>}
        {name.zh && <Descriptions.Item label="Name (中文)">{name.zh}</Descriptions.Item>}
        {data.retailPrice != null && (
          <Descriptions.Item label="Retail price">
            {data.retailPrice} {currencySymbol}
          </Descriptions.Item>
        )}
        {data.deliveryTime != null && (
          <Descriptions.Item label="Delivery (days)">{data.deliveryTime}</Descriptions.Item>
        )}
        {description.en && (
          <Descriptions.Item label="Description (English)">{description.en}</Descriptions.Item>
        )}
        {description.zh && (
          <Descriptions.Item label="Description (中文)">{description.zh}</Descriptions.Item>
        )}
        {data.gender && (
          <Descriptions.Item label="Gender">{data.gender}</Descriptions.Item>
        )}
        {data.customizable != null && (
          <Descriptions.Item label="Customizable">{data.customizable ? 'Yes' : 'No'}</Descriptions.Item>
        )}
        {data.comment && <Descriptions.Item label="Comment">{data.comment}</Descriptions.Item>}
      </Descriptions>

      {Array.isArray(data.otherPictures) && data.otherPictures.length > 0 && (
        <>
          <Title level={5} style={{ marginTop: 24 }}>Other pictures</Title>
          <Image.PreviewGroup>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {data.otherPictures.map((pic, idx) => (
                pic?.uri && (
                  <Image
                    key={idx}
                    width={120}
                    height={164}
                    style={{ objectFit: 'cover' }}
                    src={`${baseUrl}/storage/fixed-sku-other-picture/${pic.uri}`}
                    alt=""
                  />
                )
              ))}
            </div>
          </Image.PreviewGroup>
        </>
      )}

      {Array.isArray(data.sizes) && data.sizes.length > 0 && (
        <>
          <Title level={5} style={{ marginTop: 24 }}>Sizes</Title>
          <Descriptions bordered column={1} size="small">
            {data.sizes.map((size, idx) => (
              <Descriptions.Item key={idx} label={size?.name?.en || size?.value || `Size ${idx + 1}`}>
                {size?.name?.zh && `${size.name.zh} / `}{size?.value}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </>
      )}
    </div>
    </div>
  )
}

export default PublicFixSku
